@if((!isGeolocationActive() && !isFakeGPSActive() ) && routeSegments()?.length > 0 && currentTrameIndex() >= 0 && currentStepIndex() >= 0){
    <div class="step-nav-container">
        <div class="step-nav">

            <ci-fab-button 
                class="side" class-name="ci-btn-primary-outlined" type="button" icon-name="previous" aria-label="anterior"
                (touchstart)="touchStartPrev($event)" 
                (click)="prevStep()" 
                [class.hidden]="!showPrevButton() || currentStepIndex() === 0 && activeSegmentByHour()"  
            />

            <ci-fab-button 
                class="middle" class-name="ci-btn-primary-outlined" type="button" aria-label="Pasos"
                (touchstart)="touchStartMiddle($event)" 
                [class.next]="!showNextButton()" 
                [class.success]="isFinal()" 
                (click)="goNextTrame()"
            >
                @if (showNextButton()){
                    <span class="ci-paragraph-p1-semibold">
                        {{ 'Paso' | translate }} {{currentStepIndex() + 1}}/{{routeSegments()?.[currentTrameIndex()]?.transfers?.length}} 
                    </span>
                }
                @else{
                    @if (isFinal()) {
                        @if (totalDays() === dayToShowIndex()){
                            <span class="ci-paragraph-p1-semibold">
                                {{ 'Ha finalizado tu viaje' | translate }}
                            </span>
                        }
                        @else {
                            <span class="ci-paragraph-p1-semibold">
                                {{ 'Ver día' | translate }} {{ dayToShowIndex() + 2 }}
                            </span>
                        }
                    }
                    @else {
                        @if(activeSegmentByHour()){
                            <span class="ci-paragraph-p1-semibold">
                                {{ 'Ha llegado a tu destino' | translate }}
                            </span>
                        }
                        @else {
                            <span class="ci-paragraph-p1-semibold">
                                {{ 'Siguiente' | translate }}
                            </span>
                        }
                    }
                }
            </ci-fab-button>

            <ci-fab-button
                class="side" class-name="ci-btn-primary-outlined" type="button" icon-name="next" aria-label="siguiente"
                (touchend)="touchStartNext($event)" 
                (click)="nextStep()" 
                [class.hidden]="!showNextButton()"  
            />

        </div>
    </div>
}
